import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"
import { useState } from "react"
import { useDispatch } from "react-redux";
import uuid from "react-uuid";
import { colors } from "../helpers/colors";
import { addList } from "../reducers/listSlice";
import { addWells } from "../reducers/wellSlice";
import { formatUwi } from '../helpers/formatUwi';
// import userSlice from "../reducers/userSlice";


export const NewList = ({ handleNewListClose, projectId, userEmail, wellUwis }) => {
  
  const [listName, setListName] = useState("New List");
  const [listDescription, setListDescription] = useState(() => {
    if (wellUwis?.length > 0) return "Imported from Petro Ninja";
    return "";
  });
  const [uwis, setUwis] = useState(() => {
    if (wellUwis?.length > 0) {
      return wellUwis.split(',').join('\n');
    };
    return "";
  });
  const dispatch = useDispatch();

  return (
    <Dialog 
      open={true} 
      onClose={handleNewListClose}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle>New List</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="normal"
          id="name"
          label="List Name"
          placeholder="List Name"
          // defaultValue="New List"
          type="text"
          fullWidth
          value={listName}
          variant="outlined"
          onChange={e => setListName(e.target.value)}
        />

        <TextField
          margin="normal"
          id="description"
          label="Description"
          placeholder="Description"
          // defaultValue="New List"
          type="text"
          fullWidth
          multiline
          minRows={2}
          maxRows={5}
          value={listDescription}
          variant="outlined"
          onChange={e => setListDescription(e.target.value)}
        />

        <TextField
          margin="normal"
          id="uwis"
          label="Well UWIs"
          type="text"
          fullWidth
          multiline
          minRows={10}
          maxRows={10}
          value={uwis}
          variant="outlined"
          placeholder="Enter well UWIs on separate lines or separated by a comma"
          onChange={e => setUwis(e.target.value)}
        />

      </DialogContent>
      <DialogActions>
        <Button onClick={handleNewListClose} color="primary">
          Cancel
        </Button>
        <Button onClick={() => handleCreateListClick(projectId, uwis)} color="primary" variant="contained" disabled={listName.length === 0}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );

  function handleCreateListClick(projectId, uwis) {
    try {
      const id = uuid();
      const color = colors[Math.floor(Math.random() * colors.length - 1)];
      let uwiArray = uwis?.trim()?.split('\n');
      uwiArray = uwiArray.map(uwi => uwi.replaceAll(/[^a-zA-Z0-9]/ig,'')?.toUpperCase()); // remove all special characters
      uwiArray = [...new Set(uwiArray)];
      const list = {
        id,
        name: listName,
        description: listDescription,
        color,
        createdBy: userEmail || "worker@ssdynamics.com",
        createdOn: new Date().toLocaleString(),
        lastModified: new Date().toLocaleString(),
        wellUwis: (uwiArray?.length > 0 && uwiArray[0]?.length > 0 && uwiArray) || [],
        typeCurveId: undefined,
        groupWellId: undefined,
        forecastListTab: 0,
        filters: {}
      };

      let wells = {};
      for (let uwi of uwiArray) {
        if (uwi.length > 0) {
          const color = colors[Math.floor(Math.random() * colors.length - 1)];
          wells[uwi] = {
            uwi,
            formattedUwi: formatUwi(uwi),
            color,
            lastModified: new Date().toLocaleString(),
            status: 'idle'
          };
        };
      };

      dispatch(addList({projectId: (projectId || "default"), list: list}));
      dispatch(addWells({uwis: uwiArray, wells: wells, listId: id}));
      handleNewListClose();
    } catch (error) {
      console.log(error);
      return;
    };
  };
};